export enum ContentFeedType {
  RSS = 'rss',
  BANK = 'bank',
  VRSTAR = 'vrstar',
}

export enum ContentFeedContentType {
  FILE = 'file',
  ARTICLE = 'article',
  LINK = 'link',
  OFFER = 'offer',
}
